/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';

import { Feature } from '../../models';

export enum FeatureActionTypes {
  DeleteFeature = '[Feature] Delete Feature',
  UpsertFeatures = '[Feature] Upsert Features',
  UpsertFeature = '[Feature] Upsert Feature',
  SetLastYearsFeatures = '[Feature] Set last years Features',
  InteractionFeatureDrawn = '[Feature] Interaction Feature drawn',
  InteractionFeatureSelected = '[Feature] Interaction Feature selected',
  InteractionFeatureDeselected = '[Feature] Interaction Feature deselected',
  InteractionFeatureToggle = '[Feature] Interaction Feature toggle',
  InteractionRvoSelected = '[Feature] Interaction Rvo selected',
  InteractionRvoDeselected = '[Feature] Interaction Rvo deselected',
  InteractionFeatureModified = '[Feature] Interaction Feature modified',
  InteractionFeatureModifying = '[Feature] Interaction Feature modifying',
  InteractionLastYearsFeatureSelected = '[Feature] Last years feature selected',
  InteractionShapefileFieldSelected = '[Feature] Interaction shapefile field selected',
  DeselectInteractionFeatures = '[Feature] Deselect interaction Features',
  DeselectRvoFields = '[Feature] Deselect Rvo fields',
  DeselectCropFields = '[Feature] Deselect Crop fields',
  DeselectAllFields = '[Feature] Deselect all fields',
  FieldDivisionDrawn = '[Feature] Field division drawn',
  FieldOverlapDrawn = '[Feature] Field overlap drawn',
}

export class DeleteFeature implements Action {
  readonly type = FeatureActionTypes.DeleteFeature;

  constructor(public readonly id: number) {}
}

export class UpsertFeatures implements Action {
  readonly type = FeatureActionTypes.UpsertFeatures;

  constructor(public readonly features: Feature[]) {}
}

export class UpsertFeature implements Action {
  readonly type = FeatureActionTypes.UpsertFeature;

  constructor(public readonly feature: Feature) {}
}

export class SetLastYearsFeatures implements Action {
  readonly type = FeatureActionTypes.SetLastYearsFeatures;

  constructor(public readonly features: Feature[]) {}
}

export class InteractionFeatureDrawn implements Action {
  readonly type = FeatureActionTypes.InteractionFeatureDrawn;

  constructor(public readonly feature: Feature) {}
}

export class InteractionFeatureSelected implements Action {
  readonly type = FeatureActionTypes.InteractionFeatureSelected;

  constructor(public readonly id: number) {}
}

export class InteractionFeatureDeselected implements Action {
  readonly type = FeatureActionTypes.InteractionFeatureDeselected;

  constructor(public readonly id: number) {}
}

export class InteractionFeatureToggle implements Action {
  readonly type = FeatureActionTypes.InteractionFeatureToggle;

  constructor(public readonly id: number) {}
}

export class InteractionRvoSelected implements Action {
  readonly type = FeatureActionTypes.InteractionRvoSelected;

  constructor(public readonly feature: Feature) {}
}

export class InteractionRvoDeselected implements Action {
  readonly type = FeatureActionTypes.InteractionRvoDeselected;

  constructor(public readonly id: string) {}
}

export class InteractionLastYearsFeatureSelected implements Action {
  readonly type = FeatureActionTypes.InteractionLastYearsFeatureSelected;

  constructor(public readonly feature: Feature) {}
}

export class InteractionShapefileFieldSelected implements Action {
  readonly type = FeatureActionTypes.InteractionShapefileFieldSelected;

  constructor(public readonly feature: Feature) {}
}

export class InteractionFeatureModified implements Action {
  readonly type = FeatureActionTypes.InteractionFeatureModified;
}

export class InteractionFeatureModifying implements Action {
  readonly type = FeatureActionTypes.InteractionFeatureModifying;

  constructor(public readonly feature: Feature) {}
}

export class DeselectInteractionFeatures implements Action {
  readonly type = FeatureActionTypes.DeselectInteractionFeatures;
}

export class DeselectRvoFields implements Action {
  readonly type = FeatureActionTypes.DeselectRvoFields;
}

export class DeselectCropFields implements Action {
  readonly type = FeatureActionTypes.DeselectCropFields;
}

export class DeselectAllFields implements Action {
  readonly type = FeatureActionTypes.DeselectAllFields;
}

export class FieldDivisionDrawn implements Action {
  readonly type = FeatureActionTypes.FieldDivisionDrawn;

  constructor(public readonly feature: Feature) {}
}

export class FieldOverlapDrawn implements Action {
  readonly type = FeatureActionTypes.FieldOverlapDrawn;

  constructor(public readonly feature: Feature) {}
}

export type FeatureActions =
  | DeleteFeature
  | UpsertFeature
  | UpsertFeatures
  | SetLastYearsFeatures
  | InteractionFeatureDrawn
  | InteractionFeatureSelected
  | InteractionFeatureModified
  | InteractionFeatureModifying
  | InteractionFeatureDeselected
  | InteractionFeatureToggle
  | InteractionLastYearsFeatureSelected
  | InteractionRvoSelected
  | InteractionRvoDeselected
  | InteractionShapefileFieldSelected
  | DeselectInteractionFeatures
  | DeselectRvoFields
  | DeselectCropFields
  | DeselectAllFields
  | FieldDivisionDrawn
  | FieldOverlapDrawn;
